const endpoints = {
    otpSend: 'admin-utilities/otp/send',
    otpVerify : 'admin-utilities/otp/verify',
    adminList : 'admins/',
    MDList: 'admins/',
    bankList : 'banks/',
    regionalOfficeList : 'regional-offices',
    masterDistributorsList : 'master-distributors/',
    distributorsList : 'distributors/',
    subDistributorsList : 'sub-distributors/',
    agentsList : 'agents/',
    retailerList:'retailers/',
    mnoList: 'mnos/',
    manualEntries: 'manual-entries/',
    pendingAmount: 'pending-amount-transactions/',
    raiseETopUpRequest: 'cash-in',
    raiseETopUpRequestPaid: 'cash-in/paid',
    repayAdvanceETopUpRequest : 'cash-in/repay-advance',
    regionalOffices : 'regional-offices',
    target: 'mnos/targets/',
    serviceFeeTransaction: 'mnos/service-fee/',
    etopUpreceived: 'cash-in/received',
    onBoardingRequest: 'onboarding-requests/',
    companyList:'companies',
    customerList: 'customers/',
  };
  
  export default endpoints;
  